export enum EThemeKey {
	MinimapAddedLineColor,
	MinimapChangedLineColor,
	MinimapRemovedLineColor,
	AddedFileForeground,
	MovedFileForeground,
	DeletedFileForeground,
	MinimapCommentColor,
	MinorEditForeground
}
